// extracted by mini-css-extract-plugin
export default {"container":"userDataProfile_container__7aip-","looking":"userDataProfile_looking__qG9rQ","aboutMe":"userDataProfile_aboutMe__7onga"};